<template>
  <article class="card-custom ra">
    <div class="dg-card-title">
      {{ nombreCuenta ? `Evolución anual — ${nombreCuenta}` : "Resumen general anual ONEST" }}
    </div>
    <div class="dg-card-sub">
      Evolución consolidada de Customer Experience {{ rangoAnios }}. Lectura
      anual: el servicio no expone el mes de la ejecución.
    </div>

    <!-- ============ GRÁFICA COMPUESTA ============ -->
    <AnnualComposedChart :serie="serie" :benchmark="benchmark" />

    <!-- ============ TARJETAS DE TITULAR ============ -->
    <div class="ra-highlights">
      <div
        v-for="h in resumen.highlights"
        :key="h.label"
        class="ra-hl"
        :class="'tone-' + h.tone"
      >
        <span class="ra-hl-label">{{ h.label }}</span>
        <span class="ra-hl-value">{{ h.value }}</span>
      </div>
    </div>

    <!-- ============ LECTURAS EJECUTIVAS ============ -->
    <div class="ra-lecturas">
      <div class="ra-lecturas-title">Lectura ejecutiva</div>
      <ul>
        <li
          v-for="(l, i) in resumen.lecturas"
          :key="i"
          :class="{ 'ra-alerta': l.startsWith('Atención') }"
        >
          {{ l }}
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
import AnnualComposedChart from "./AnnualComposedChart.vue";

export default {
  name: "ResumenAnual",
  components: { AnnualComposedChart },
  props: {
    // Serie de evolucionAnual(): [{ anio, score, nps, ces, csat, encuestas,
    // cuentas, cobertura }]
    serie: { type: Array, default: () => [] },
    // Salida de construirResumenAnual(): { highlights, lecturas }
    resumen: { type: Object, default: () => ({ highlights: [], lecturas: [] }) },
    // Serie ONEST global de referencia cuando se acota a una cuenta.
    benchmark: { type: Array, default: null },
    nombreCuenta: { type: String, default: null },
  },

  computed: {
    rangoAnios() {
      if (!this.serie.length) return "—";
      const primero = this.serie[0].anio;
      const ultimo = this.serie[this.serie.length - 1].anio;
      return primero === ultimo ? String(primero) : `${primero}–${ultimo}`;
    },
  },

};
</script>

<style scoped>
/* Los títulos reusan las clases de DashboardGeneral, que no son scoped-safe
   entre componentes; se redeclaran aquí para que la tarjeta sea autónoma. */
.dg-card-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--heading);
}
.dg-card-sub {
  font-size: 12px;
  color: var(--txt-dim);
  margin-bottom: 16px;
  line-height: 1.4;
}

/* ---------- Titulares ---------- */
.ra-highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
  margin-bottom: 22px;
}

.ra-hl {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  background: var(--surface);
}

.ra-hl-label {
  font-size: 10px;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--txt-faint);
}

.ra-hl-value {
  font-size: 14px;
  font-weight: 700;
  color: var(--txt);
}

.tone-success {
  border-color: rgba(67, 178, 52, 0.4);
}
.tone-success .ra-hl-value {
  color: var(--verde);
}
.tone-danger {
  border-color: rgba(255, 93, 115, 0.4);
}
.tone-danger .ra-hl-value {
  color: var(--rojo);
}
.tone-warning {
  border-color: rgba(255, 194, 75, 0.5);
}
.tone-primary {
  border-color: rgba(26, 92, 201, 0.35);
}
.tone-primary .ra-hl-value {
  color: var(--brand-text);
}

/* ---------- Lecturas ---------- */
.ra-lecturas {
  margin-top: 22px;
  border-top: 1px solid var(--border);
  padding-top: 14px;
}

.ra-lecturas-title {
  font-size: 10px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  font-weight: 700;
  color: var(--txt-faint);
  margin-bottom: 8px;
}

.ra-lecturas ul {
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ra-lecturas li {
  font-size: 12.5px;
  color: var(--txt-dim);
  line-height: 1.5;
}

.ra-alerta {
  color: var(--txt);
  font-weight: 600;
}
.ra-alerta::marker {
  color: var(--warn);
}
</style>
